import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { Invoice } from 'src/app/modelo/Invoice';
import { ComprobantesService } from 'src/app/services/comprobantes.service';
import { environment } from 'src/environments/environment';
import { InvoiceGlobal } from 'src/app/modelo/InvoiceGlobal';
import { validateDNIPattern } from 'src/app/shared/helpers';
import { ContactosService } from 'src/app/contactos/contactos.service';
import { SubjectCustomer } from '../modelo/SubjectCustomer';
import { Subject } from '../modelo/Subject';
import { DataService } from '../services/data.service';

import { AdministracionService } from 'src/app/administracion/administracion.service';
import { validateDni } from 'src/app/shared/helpers';
import { validateRUC } from 'src/app/shared/helpers';
import { validateEmail } from 'src/app/shared/helpers';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FazilController } from '../core/fazil-controller-component';
import { FormBuilder } from '@angular/forms';
import { SubjectCustomerOutput } from '../core/models/contacto.model';

@Component({
    selector: 'app-contactos',
    templateUrl: './contactos.component.html',
    styleUrls: ['./contactos.component.scss']
})
export class ContactosComponent  extends FazilController  implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    contactos: SubjectCustomer[] = [];
    
    //Variables auxiliares
    cols: any[];
    multiSortMeta = [];
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    buttonsActions: any[] = [];
    mostrarEditor: boolean = false;
    //code: string;
    verificandoData: any;
    verificando: boolean = false;
    subjectCode: string;
    subjectNUI: string;
    subjectCodeValid: boolean = false;
    emailValid: boolean = true; //Todo correo es valido para el cliente
    enEdicion: boolean = false;

    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;

    objNombreSg: string = "contacto";
    objNombrePl: string = "contactos";
    
    etiquetaCIRUC: string = 'C.I';
    
    subjectCustomer:SubjectCustomer; //Para editar contactos

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private contactosService: ContactosService,
        private sanitizer: DomSanitizer,
        public override uiService: UIService,
        public override messageService: MessageService,
        public override administracionService: AdministracionService,
        public override _formBuilder: FormBuilder
    ) {
        super(uiService, messageService, administracionService, _formBuilder);
        this.cargarDataConstructor();
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([{ label: 'Contactos/Clientes', routerLink: ['contactos'] }]);
        this.cols = [
            { field: 'customerFullName', header: 'Nombres', visible: true },
            { field: 'customerCode', header: 'C.I./RUC', visible: true },
            { field: 'customerEmail', header: 'Correo electrónico', visible: true },
            { field: 'customerMobileNumber', header: 'Teléfono', visible: true },
            { field: 'customerCiudad', header: 'Ciudad', visible: true },
        ];
        this.multiSortMeta.push({ field: 'customerFullName', order: 1 });
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe((userData) => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        
        const data = await this.contactosService.getContactosPorUsuarioConectadoData(this.pageOptions);
        this.contactos = data['content'];
        this.totalRecords = data['totalElements'];
        
        this.cargandoDataInit = false;
    }

    presentarOpcionesActionSheet(event, item: SubjectCustomer) {
        this.buttonsActions = [
            {
                text: 'Editar contacto',
                icon: 'pi pi-user-edit',
                cssClass: 'p-button-text p-button-info',
                action: 'editar',
                data: item,
                disabled: false
            }, {
                text: 'Eliminar contacto',
                icon: 'pi pi-trash',
                cssClass: 'p-button-text p-button-danger',
                action: 'eliminar',
                data: item,
                disabled: item.tieneFaturas ? true : false,
            },
        ];
    }

    async ejecutarAccion(event, accion: string, sc: SubjectCustomer) {
        this.ui.limpiarMessages();
        if (accion == 'editar') {
            if (sc.id) {
                sc.customer = await this.contactosService.getContactoIdData(sc.id);
                this.subjectCustomer = sc; //El objeto a editar
                this.mostrarEditor = true;
            }
        } else if (accion == 'eliminar') {
            this.eliminarItemConfirm(sc);
        }
    }

    resetearVariables() {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
    }

    eliminarItemConfirm(item: SubjectCustomer) {
        this.resetearVariables();
        this.confirmationService.confirm({
            message: this.ui.buildMsgConfirm(this.appConfig.properties.defaultActions.execute.delete, item.customerFullName),
            accept: () => {
                this.eliminarItem(item);
            },
        });
    }


    eliminarItem(item: SubjectCustomer) {
        console.log(item);
        this.contactosService.borrarContacto(item.uuid).subscribe(
            async (data) => {
                const result = await this.contactosService.getContactosPorUsuarioConectadoData(this.pageOptions);
                this.contactos = result['content'];
                this.totalRecords = result['totalElements'];
                this.ui.mostrarMensaje(`${this.appConfig.primeng.severities.execute.success}`,
                    `${this.ui.buildMsgSubscribe(this.appConfig.properties.defaultActions.execute.delete, this.objNombreSg, item.customerFullName, false)}`);
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    nuevoContacto() {
        this.subjectCustomer = new SubjectCustomer();//Objeto principal de edición
        this.subjectCustomer.customer = new Subject(); //Inicializa objeto auxiliar
        this.mostrarEditor = true;
    }

    /**
     ** Métodos de formulario
     **/
    resetVariables(): void {
        this.ui.limpiarMessages();
    }
    
    async handlePagination(paginationData){
        
        const page = paginationData.page;
        this.pageOptions = { page: page, pageSize: this.rows, filter: this.search, orderBy: 'name', order:'ASC'};
        const data = await this.contactosService.getContactosPorUsuarioConectadoData(this.pageOptions);
        this.contactos = data['content'];
    }
    
    async filteredContactByKeyword(event){
        this.search = event.target.value;
        this.pageOptions = { page: 0, pageSize: this.rows, filter: this.search, orderBy: 'name', order:'ASC'};
        const page = await this.contactosService.getContactosPorUsuarioConectadoData(this.pageOptions);
        this.contactos = page['content'];
        this.totalRecords = page['totalElements'];
    }
    
    handleContactoGuardado(subjectCustomerOutput:SubjectCustomerOutput){

        //TODO hacer algo con los datos que regresan
        this.mostrarEditor = false;
    }
}
